<template>
  <div class="pagoda-table-v2">
    <cache-columns-width :cache-key="cacheWidthKey">
      <el-table
        :data="tableData"
        @sort-change="handleSortChange"
        @hook:mounted="methodsProxy"
        v-on="$listeners"
        v-bind="$attrs"
        ref="elTable"
      >
        <!-- 配置渲染table-column -->
        <render-table-columns
          v-if="columns"
          :columns="columns"
        >
          <template
            slot-scope="scope"
            :slot="slotName"
            v-for="(_, slotName) in $scopedSlots"
          >
            <slot
              :name="slotName"
              v-bind="scope"
            ></slot>
          </template>
        </render-table-columns>
        <!-- 插槽直接传入table-column -->
        <slot v-else />
      </el-table>
    </cache-columns-width>
    <el-pagination
      v-if="hasPagination"
      class="pagoda-pagination"
      :current-page="table.state.pagination.currentPage"
      v-bind="paginationConfig"
      @current-change="table.handleCurrentChange"
      @size-change="table.handleSizeChange"
      ref="elPagination"
    />
  </div>
</template>

<script>
import TableRequest from './request'
import RenderTableColumns from './render-table-columns'
import CacheColumnsWidth from '../cache-columns-width/cache-columns-width'
import { getEmptyObject, methodsProxy } from '../../../utils'

const METHODS_PROXY_MAP = [
  'clearSelection',
  'toggleRowSelection',
  'toggleAllSelection',
  'toggleRowExpansion',
  'setCurrentRow',
  'clearSort',
  'clearFilter',
  'doLayout',
  'sort'
]

const PAGINATION_DEFAULT = {
  show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  background: true
}

export default {
  inheritAttrs: false,
  name: 'TableV2',
  components: {
    RenderTableColumns,
    CacheColumnsWidth
  },
  props: {
    data: Array,
    request: Function,
    columns: Array,
    cacheColumnsWidth: Boolean,
    cacheKey: String,
    autoRequest: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Object,
      default: getEmptyObject
    }
  },
  computed: {
    paginationConfig() {
      return Object.assign(
        {},
        PAGINATION_DEFAULT,
        {
          total: this.table.state.pagination.total
        },
        this.pagination
      )
    },
    tableData() {
      return this.data || this.table.state.data
    },
    hasPagination() {
      return this.paginationConfig.show && (!!this.request || this.$listeners.request)
    },
    cacheWidthKey() {
      return this.cacheColumnsWidth ? this.cacheKey : null
    }
  },
  watch: {
    tableData() {
      if (!this.tableData.includes(this.radioSelect)) {
        this.clearRadio()
      }
    },
    radioSelect() {
      this.$emit('radio-change', this.radioSelect)
    }
  },
  data() {
    this.table = new TableRequest(this.paginationConfig)
    this.table.onRequest(this.request)
    this.table.onRequest((...arg) => this.$emit('request', ...arg))

    return {
      radioSelectIdx: null,
      radioSelect: null
    }
  },
  created() {
    if (this.autoRequest) this.table.refresh()
  },
  methods: {
    refresh() {
      this.table.refresh()
    },
    refreshCurrentPage() {
      this.table.refreshCurrentPage()
    },
    setCurrentRadio(row) {
      const rowIndex = this.tableData.findIndex(rowData => rowData === row)

      if (rowIndex !== -1) {
        this.radioSelectIdx = rowIndex
        this.radioSelect = row
      }
    },
    clearRadio() {
      this.radioSelectIdx = null
      this.radioSelect = null
    },
    methodsProxy() {
      // proxy elTable methods to instance
      methodsProxy(this, this.$refs.elTable, METHODS_PROXY_MAP)
    },
    handleSortChange(sortable) {
      if (sortable.column.sortable === 'remote') {
        this.table.handleSortChange(sortable)
      }
    }
  }
}
</script>
